import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SidebarState {
  collapsed: boolean;
  onExpand: () => void;
  onCollapse: () => void;
  toggle: () => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      collapsed: false,
      onExpand: () => set({ collapsed: false }),
      onCollapse: () => set({ collapsed: true }),
      toggle: () => set((state) => ({ collapsed: !state.collapsed })),
    }),
    {
      name: "sidebar-storage",
    }
  )
);
